import { ActionTree } from "vuex";
import {
    PortalSubtopicAsideWidgetState,
    IPortalSubtopicRelatedPagesWidgetModel,
    IPortalSubtopicContactWidgetModel
} from "@/apps/PortalSubtopicAsideWidget/models/PortalSubtopicAside-widget-state";

export default <ActionTree<PortalSubtopicAsideWidgetState, PortalSubtopicAsideWidgetState>>{
    async init(context, props) {
        await context.commit('setRelatedPages', props.relatedPages);
        await context.commit('setContactInformation', props.contactInformation);
        await context.commit('setSelectedFaculty', '');
    }
}
